import { render, staticRenderFns } from "./PersonalItems.vue?vue&type=template&id=3b471668"
import script from "./PersonalItems.vue?vue&type=script&lang=ts"
export * from "./PersonalItems.vue?vue&type=script&lang=ts"
import style0 from "./PersonalItems.vue?vue&type=style&index=0&id=3b471668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports